<template>
  <div id="inspire">
    <!-- <eps-sidebar></eps-sidebar> -->
      <eps-header :drawer="$store.state.drawer"></eps-header>
      <v-divider></v-divider>
      <div v-show="isExactActive">

      <epsCard></epsCard>
    </div>
    <v-content>  
      <v-container fluid>
         <router-link class="button no-display menulink" v-show="!isExactActive" to="/eps-management-home">
          <!-- <v-icon large>mdi-menu</v-icon>  -->
          <v-icon >mdi-arrow-left-bold</v-icon> 

          
          </router-link>

         <router-view ref="rv">
           
         </router-view>
      </v-container>
    </v-content>
  </div>
</template>
<script>
import mgmtSidebar from "./Sidebar";
import epsHeader from "./Header"; 
import epsCard from "./CardView"
export default {
  data: () => ({
   isExactActive:true
    
  }),
  components: {
    'eps-sidebar': mgmtSidebar,
     'epsHeader': epsHeader,
     'epsCard' : epsCard,
  },
 updated() {
      this.isExactActive = typeof this.$refs.rv === 'undefined';
  },

  mounted() {
      this.isExactActive = typeof this.$refs.rv === 'undefined';
  },
  //  beforeRouteLeave(to, from,next) {
  //     console.log("to",to.path)
  //     console.log("tok",localStorage.getItem('Mngt-EPS-token'))
  //     alert("hi")
  //       if(to.path=="/management-login" && localStorage.getItem('Mngt-EPS-token')!=null){
  //        // this.$router.push("/eps-management-home")
  //       }
  //       else
  //       next()
  //   }
 
};
</script>


<style scoped>
.menulink{
  text-decoration: none;
}

</style>